/**
 * @param {strin} en text en
 * @param {string} ar text ar
 * @returns if lang === ar return text ar else return en
 */
export const dir = (en = '', ar = '') => {
  return localStorage.getItem('lang') === 'ar' ? ar : en;
};
